import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<
    'primary' | 'secondary' | 'tertiary' | 'error' | 'warning' | 'success' | 'informative' | 'goGreen' | 'inherit'
  >
}>

/**
 * Body2
 *
 * Demos:
 * - [Body2](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-typography--docs)
 *
 */

export const Body2 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="body2" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
